export const TRANSITIONS = {
  LINEAR_400: '--transition-linear-400',
  LINEAR_300: '--transition-linear-300',
  LINEAR_200: '--transition-linear-200',
  LINEAR_150: '--transition-linear-150',
  LINEAR_100: '--transition-linear-100',
  PLAYER_DEFAULT: '--transition-player-default',
} as const
export type TRANSITIONS = (typeof TRANSITIONS)[keyof typeof TRANSITIONS]
